import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {
  makeObservable,
  observable,
  action,
  runInAction,
  computed,
} from 'mobx';
import { UserCount } from '../components/Header/type';

const SECTION_NAME = {
  TOTAL: 'Members',
  ACTIVATED: 'Activated Memebers',
  SUSPENDED: 'Suspended Members',
  DELETED: 'Deleted Members',
  DELETED_BYUSER: 'To be deleted Members (by Member)',
  DELETED_BYADMIN: 'To be deleted Members (by Admin)',
};

export default class DashboardStore {
  constructor() {
    makeObservable(this, {
      latestDate: observable,
      userCount: observable,
      chartData: observable,
      isLoading: observable,
      isChartLoading: observable,
      getLocaleString: computed,
      setUserCount: action,
      setChartData: action,
      updateChartData: action,
      userUpdate: action,
      sectionValue: action,
      // sectionLabels: observable,
    });
  }

  latestDate = '';

  userCount: any = {
    users: [
      {
        count: 1461,
        name: 'ACTIVATED',
      },
      {
        count: 1152,
        name: 'DELETED',
      },
      {
        count: 5,
        name: 'SUSPENDED',
      },
    ],
    badges: [
      {
        count: 0,
        name: 'OFFICIAL_CHANNEL',
        image: 'https://resource.kinemaster.com/image/official_badge.png',
      },
      {
        count: 0,
        name: 'POWER_CREATOR_GOLD',
        image:
          'https://resource.kinemaster.com/image/power_creator_badge_gold.png',
      },
      {
        count: 0,
        name: 'POWER_CREATOR_BLACK',
        image:
          'https://resource.kinemaster.com/image/power_creator_badge_black.png',
      },
      {
        count: 0,
        name: 'POWER_CREATOR_PURPLE',
        image:
          'https://resource.kinemaster.com/image/power_creator_badge_purple.png',
      },
      {
        count: 0,
        name: 'POWER_CREATOR_ORANGE',
        image:
          'https://resource.kinemaster.com/image/power_creator_badge_orange.png',
      },
      {
        count: 0,
        name: 'POWER_CREATOR_BLUE',
        image:
          'https://resource.kinemaster.com/image/power_creator_badge_blue.png',
      },
      {
        count: 0,
        name: 'POWER_CREATOR_GREEN',
        image:
          'https://resource.kinemaster.com/image/power_creator_badge_green.png',
      },
      {
        count: 0,
        name: 'CERTIFIED_INSTRUCTOR',
        image: 'https://resource.kinemaster.com/image/certified_badge.png',
      },
      {
        count: 0,
        name: 'SUPPORTER',
        image: 'https://resource.kinemaster.com/image/support_badge.png',
      },
      {
        count: 0,
        name: 'GOLD',
        image: 'https://resource.kinemaster.com/image/k-awards-gold.png',
      },
      {
        count: 0,
        name: 'SILVER',
        image: 'https://resource.kinemaster.com/image/k-awards-silver.png',
      },
      {
        count: 0,
        name: 'BRONZE',
        image: 'https://resource.kinemaster.com/image/k-awards-bronze.png',
      },
      {
        count: 0,
        name: 'KINEMASTER_CHALLENGE',
        image: 'https://resource.kinemaster.com/image/ic_badge_challenge.png',
      },
      {
        count: 0,
        name: 'SPRING_CHALLENGE',
        image: 'https://resource.kinemaster.com/image/SP_Challenge.png',
      },
    ],
  };

  chartData: any = {
    totalWhiteListCount: 0,
    labels: [],
    datasets: [
      {
        newbies: [],
      },
      {
        youtubeChannelRegistration: [],
      },
    ],
  };

  sectionLabels = [
    SECTION_NAME.TOTAL,
    SECTION_NAME.ACTIVATED,
    SECTION_NAME.SUSPENDED,
    SECTION_NAME.DELETED_BYUSER,
    SECTION_NAME.DELETED_BYADMIN,
    SECTION_NAME.DELETED,
  ];

  setUserCount = action((res: UserCount) => {
    this.userCount = res;
  });

  isLoading = true;
  
  isChartLoading = true;

  sectionValue = action((label: string) => {
    switch (label) {
      case SECTION_NAME.TOTAL:
        return this.getLocaleString.allUserCount;
      case SECTION_NAME.ACTIVATED:
        return this.getLocaleString.activatedUserCount;
      case SECTION_NAME.SUSPENDED:
        return this.getLocaleString.suspendedUserCount;
      case SECTION_NAME.DELETED:
        return this.getLocaleString.deletedUserCount;
      case SECTION_NAME.DELETED_BYUSER:
        return this.getLocaleString.toBeDeletedByUserCount;
      case SECTION_NAME.DELETED_BYADMIN:
        return this.getLocaleString.toBeDeletedByAdminCount;
      default:
        return 0;
    }
  });

  userUpdate = action(async () => {
    this.isLoading = true;

    const baseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    const userCountUrl = process.env.REACT_APP_DASHBOARD_USER_COUNT_URL;
    const data = await fetch(`${baseUrl}${userCountUrl}`, {
      cache: 'no-store',
    });

    if (!data) return;
    data.json().then((res) => {
      runInAction(() => {
        const age = Number(data.headers.get('age'));
        dayjs.extend(utc);
        const nowDate = dayjs(new Date()).utc();
        const latestDate = nowDate
          .subtract(age, 'second')
          .format('YYYY-MM-DD HH:mm:ss');
        this.setUserCount(res);
        this.isLoading = false;
        this.latestDate = latestDate;
      });
    });
  });

  setChartData = action((data: any) => {
    this.chartData = {
      totalWhitelistCount: data.totalWhitelistCount,
      labels: data.dailyData.map((item: any) => item.date),
      datasets: [
        {
          newbies: data.dailyData.map((item: any) => item.userCount),
        },
        {
          youtubeChannelRegistration: data.dailyData.map((item: any) => item.whitelistCount),
        },
      ],
    };
  });

  updateChartData = action(async (startDate: Date, endDate: Date) => {
    this.isChartLoading = true;

    console.log('startDate', startDate.toISOString().slice(0, 10));
    console.log('endDate', endDate.toISOString().slice(0, 10));
    console.log(`${process.env.REACT_APP_DASHBOARD_BASE_URL}${process.env.REACT_APP_DASHBOARD_CHART_DATA_URL}?startDate=${startDate.toISOString().slice(0, 10)}&endDate=${endDate.toISOString().slice(0, 10)}`);

    const baseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    const chartDataUrl = process.env.REACT_APP_DASHBOARD_CHART_DATA_URL;
    const data = await fetch(`${baseUrl}${chartDataUrl}?startDate=${startDate.toISOString().slice(0, 10)}&endDate=${endDate.toISOString().slice(0, 10)}`, {
      cache: 'no-store',
    });
    if (!data) {
      this.isChartLoading = false;
      return;
    }
    data.json().then((res) => {
      runInAction(() => {
        /*
        {
  "totalWhitelistCount": 5000, // 현재까지 whitelist 총 가입된 숫자
  "dailyData": [
    {
      "date": "2025-12-30",
      "userCount": 5, // 신규 회원 가입 숫자
      "whitelistCount": 10 // 소스 오디오 화이트리스트 등록 숫자
    },    {
      "date": "2025-12-29",
      "userCount": 10,
      "whitelistCount": 20
    }
  ]
}
        */
        // 만약 res.dailyData가 없으면 가짜 데이터를 만들어서 차트용 데이터에 할당합니다.
        let fakeData = res;
        if (!res || !Array.isArray(res.dailyData) || res.dailyData.length === 0) {
          dayjs.extend(utc);
          // startDate와 endDate를 이용해서 날짜 배열 만들기
          const format = 'YYYY-MM-DD';
          const start = dayjs.utc(startDate);
          const end = dayjs.utc(endDate);
          const days = end.diff(start, 'day') + 1;
          const dailyData = [];

          for (let i = 0; i < days; i += 1) {
            const date = start.add(i, 'day').format(format);
            dailyData.push({
              date,
              userCount: Math.floor(50 + Math.random() * 50),
              whitelistCount: Math.floor(30 + Math.random() * 30),
            });
          }

          fakeData = {
            totalWhitelistCount: Math.floor(5000 + Math.random() * 5000),
            dailyData,
          };
        }
        console.log('fakeData', fakeData.dailyData);
        this.setChartData(fakeData);
        this.isChartLoading = false;
      });
    }).catch((err) => {
      console.error('Error updating chart data:', err);
      runInAction(() => {
        this.isChartLoading = false;
      });
    });
  });

  get getLocaleString() {
    const resultObject = Object.assign(this.userCount);
    const keyArray = Object.keys(resultObject);
    keyArray.forEach((key) => {
      resultObject[key] = resultObject[key].toLocaleString();
    });

    return resultObject;
  }
}
